import { useSelector } from 'react-redux';
import checkEsriMapAccess from '@rsos/utils/checkEsriMapAccess';
import usePortalType from '@rsos/utils/usePortalType';

export const useEsriAccess = () => {
  const { isPremiumUser } = usePortalType();
  const mapAccess = useSelector(checkEsriMapAccess);
  return mapAccess && isPremiumUser;
};
